import { render, staticRenderFns } from "./TransportersCard.vue?vue&type=template&id=543bd0f8&scoped=true"
import script from "./TransportersCard.vue?vue&type=script&lang=js"
export * from "./TransportersCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543bd0f8",
  null
  
)

export default component.exports